/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  name: z.string(),
  unit: z.string(),
  scope_kind: z.string(),
  material_id: z.number().nullable(),
  work_type_id: z.number().nullable(),
  work_subtype_id: z.number().nullable(),
  work_detail_id: z.number().nullable(),
  upper_limit: z.number().nullable(),
  lower_limit: z.number().nullable(),
  judge_required: z.boolean(),
  timing_category: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const QualityMeasurementItemBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type QualityMeasurementItemBase = z.infer<typeof base>;
export type QualityMeasurementItemBasePutPayload = z.infer<typeof put>;
export type QualityMeasurementItemBasePatchPayload = z.infer<typeof patch>;
export type QualityMeasurementItemBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type QualityMeasurementItemBaseCreateAttributes = z.infer<typeof create>;
export type QualityMeasurementItemBaseUpdateAttributes = z.infer<typeof update>;
export type QualityMeasurementItemBaseCacheAttributes = z.infer<typeof cache>;
export type QualityMeasurementItemBaseCachesAttributes = z.infer<typeof caches>;